import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/utils';

interface ProfileNarrativeDropzoneProps {
  children: React.ReactNode;
  onDropFiles: (files: FileList | File[]) => void;
}

export function ProfileNarrativeDropzone({ children, onDropFiles }: ProfileNarrativeDropzoneProps) {
  const [isDragOver, setIsDragOver] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col px-3 pt-2 pb-3">
      <div
        className="relative flex flex-1 flex-col"
        onDragLeave={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentTarget = e.currentTarget;
          const relatedTarget = e.relatedTarget as Node | null;

          if (relatedTarget && currentTarget.contains(relatedTarget)) {
            return;
          }

          setIsDragOver(false);
        }}
        onDragOver={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragOver(true);
        }}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragOver(false);
          if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onDropFiles(e.dataTransfer.files);
          }
        }}
      >
        {children}
        {isDragOver && (
          <div
            className={cn(
              'pointer-events-none absolute inset-0 flex flex-col items-center justify-center rounded-[12px] border border-dashed border-border-strong bg-back-bg2',
            )}
          >
            <p className="text-tertiary text-center font-['Inter'] text-[14px] leading-[160%] font-medium tracking-[0%]">
              {t('profile.dropzone.dropHere')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
